module.exports = __webpack_public_path__ + "img/suporte_tg.052383ba.webp";